import styled from 'styled-components';

import { toMedium } from 'styleUtils/mediaQueries';

interface Props {
    src: string;
    fallback: string;
}
export const Image = styled.div<Props>`
    background-image: ${({ fallback }) => `url(${fallback})`};
    .webp & {
        background-image: ${({ src }) => `url(${src})`};
    }

    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    ${toMedium`
    display: none;
  `};
`;
